var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlayArrow = function SvgPlayArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.314 6.208 7.933 4.521a1.45 1.45 0 0 1 0 2.542l-7.933 4.52C8.292 18.376 7 17.665 7 16.52V7.48c0-1.144 1.292-1.855 2.314-1.272v0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayArrow);
export default ForwardRef;